"use client";

import { Dispatch, SetStateAction } from "react";

import { LinkButton } from "@/components/links/LinkButton";
import { SoftText } from "@/components/text/SoftText";
import { IsolationConstructedNoDates } from "@/types/types";
import { formatDateForOutput } from "@/utils/formatTime/formatDateForOutput";
import { useIsClient } from "@/utils/hooks/useIsClient";

export function BottomRow({
  isolation,
  open,
  setOpen,
}: {
  isolation: IsolationConstructedNoDates;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const isClient = useIsClient();

  return (
    <div className="mt-2 flex justify-between gap-x-1">
      <SoftText elementType="p" className="truncate">
        {isClient &&
          formatDateForOutput({
            date: new Date(isolation.createdAtString),
            withTime: true,
            withYear: false,
          })}{" "}
        | {isolation.name}
      </SoftText>

      <LinkButton onClick={() => setOpen((prevOpen) => !prevOpen)}>
        {open ? "Less" : "More"}
      </LinkButton>
    </div>
  );
}
